<template>
  <router-view />
</template>

<script>
export default {
  name: 'Link'
}
</script>
